module.exports = __webpack_public_path__ + "img/avatar.81eaa654.png";